import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useAppSelector } from '../../../../hooks/store-hooks';
import { useUIService } from '../../../../../use-cases/ui';
import { useNavigate } from 'react-router-dom';
import { Home } from '@mui/icons-material';

import ListIcon from '@mui/icons-material/List';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export const ListItems = (props: { isMenuOpen: boolean }) => {
  // State
  const { activePage } = useAppSelector((state) => state.ui)
  // Use State
  // Hook
  const { setActivePage } = useUIService()
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <ListItemButton
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        selected={activePage === 'Geo-Veles/'}
        onClick={() => {
          setActivePage({
            pageKey: 'Geo-Veles/'
          })
          navigate('/geo-veles')
        }}
      >
        <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
          <Home />
        </ListItemIcon>
        {
          props.isMenuOpen &&
          <ListItemText
            primary="Página Inicial"
            sx={{ ml: 2, alignItems: 'center', pt: 0.3 }}
          />
        }
      </ListItemButton>

      <ListItemButton
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        selected={activePage === 'Geo-Veles/Projetos'}
        onClick={() => {
          setActivePage({
            pageKey: 'Geo-Veles/Projetos'
          })
          navigate('/geo-veles/projetos')
        }}
      >
        <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
          <ListIcon />
        </ListItemIcon>
        {
          props.isMenuOpen &&
          <ListItemText
            primary="Projetos"
            sx={{ ml: 2, alignItems: 'center', pt: 0.3 }}
          />
        }

      </ListItemButton>

      <ListItemButton
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        selected={activePage === 'Geo-Veles/Extracoes'}
        onClick={() => {
          setActivePage({
            pageKey: 'Geo-Veles/Extracoes'
          })
          navigate('/geo-veles/extracoes')
        }}
      >
        <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
          <CloudDownloadIcon />
        </ListItemIcon>
        {
          props.isMenuOpen &&
          <ListItemText
            primary="Extrações"
            sx={{ ml: 2, alignItems: 'center', pt: 0.3 }}
          />
        }
      </ListItemButton>
    </React.Fragment >
  )
}